<dx-popup title="Notes" [width]="800" [height]="'auto'" [(visible)]="visible" [hideOnOutsideClick]="false" (onHiding)="onHiding($event)">
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
    </dxi-popup-toolbar-item>
    <app-dispatch-notes-detail #dispatchNotesDetailComponent></app-dispatch-notes-detail>
</dx-popup>
